import { Icon, Button } from "@trimble/modus-cmx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useAccount } from "@/context/account";
import type { SettingsNavState } from "@/pages/Settings/NotificationSettings/types/NotificationSettingType";

const TOOLBAR_NAV_STATE: SettingsNavState = { source: "toolbar" };

function SettingsMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { accountRouteId } = useAccount();

  const handleClick = () => {
    if (!accountRouteId) return;
    navigate(`/${accountRouteId}/settings`, { state: TOOLBAR_NAV_STATE });
  };

  return (
    <Button
      shape="circle"
      color="neutral"
      onButtonClick={handleClick}
      variant="borderless"
      aria-label={t("global_settings.settings")}
    >
      <Icon name="settings" />
    </Button>
  );
}

export default SettingsMenu;
